import { toPairs } from "lodash";

export const isGuestPage = () => {
    let returnVal = false;
    const pathname = window.location.pathname;
    const prefix = process.env.PUBLIC_URL;
    const guestPages = [
        `${prefix}/`,
        `${prefix}/2fa-verification`,
        `${prefix}/forgot-password`,
    ];
    if (guestPages.includes(pathname)) {
        returnVal = true;
    }
    if (!returnVal) {
        const resetPasswordPages = [
            `${prefix}/reset-password`,
            `${prefix}/setup-password`,
        ];
        resetPasswordPages.map((rp) => {
            if (pathname.startsWith(rp)) {
                returnVal = true;
            }
            return true;
        });
    }
    return returnVal;
}

export const envSpecificCode = (mode = "uat", callback = () => { }) => {
    const env = getEnv(mode);
    if (env.includes(process.env.REACT_APP_MODE)) {
        callback();
    }
}

const getEnv = (mode) => {
    if (mode === "uat") {
        return ["uat", "uat-x", "dev"];
    }
    if (mode === "dev") {
        return ["dev"];
    }
    if (mode === "prod") {
        return ["prod", "prod-x"];
    }
    return [];
}

export const isEnv = (mode = "uat") => {
    const env = getEnv(mode);
    if (env.includes(process.env.REACT_APP_MODE)) {
        return true;
    }
    return false;
}

export const appendBaseUrl = (url = "") => {
    let baseUrl = "";
    if (typeof window !== 'undefined') {
        baseUrl = window.location.protocol + '//' + window.location.host; // (or whatever)
    }
    return baseUrl + url
}

export const getUrlParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
        params[key] = value;
    }
    return params;
}

export const getHomepageLink = (roleId) => {
    if (roleId === false) {
        return "/";
    }
}

export const queryString = (obj) => {
    return toPairs(obj).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
}